var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubePequeaCentradaNaranjaBirdybuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 64,
    viewBox: "0 0 277 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.415 0H11.334C5.07108 0 0 5.10081 0 11.4005C0 17.7003 5.07108 22.8011 11.334 22.8011H149.401C153.973 22.8011 157.679 26.5286 157.679 31.1281C157.679 35.7275 153.973 39.455 149.401 39.455H44.8809C38.1412 39.455 32.6801 44.9482 32.6801 51.7275C32.6801 58.5068 38.1412 64 44.8809 64H237.602C243.973 64 249.153 58.812 249.153 52.3815C249.153 45.9727 243.995 40.7629 237.602 40.7629H208.238C205.09 40.7629 202.538 38.2108 202.538 35.0627C202.538 31.9145 205.09 29.3624 208.238 29.3624H262.415C270.477 29.3624 277 22.8011 277 14.6921C277 6.58308 270.477 0.0217864 262.415 0.0217864V0Z",
    fill: "#FFD2B0",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubePequeaCentradaNaranjaBirdybuyer);
export default __webpack_public_path__ + "static/media/nube-pequeña-centrada-naranja-birdybuyer.0751013bcdf7de0e50b8a49ab3e6c4e5.svg";
export { ForwardRef as ReactComponent };